/** @jsxImportSource @emotion/react */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import {
  List,
  ListItem,
  Link,
  MenuTitle,
  MoreButton,
  HeaderMenu,
  Card,
  hide,
} from './styles'

export { List, Link, ListItem }

export default function SideMenu({ submenu, children }) {
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const onToggleMenu = () => {
    setShowMobileMenu(!showMobileMenu)
  }

  const renderMenuItem = (item) => (
    <ListItem key={`side-menu-${item.label}`}>
      <Link exact to={item.link} activeClassName="active-submenu">
        {item.label}
      </Link>
    </ListItem>
  )

  const renderContent = () => {
    if (submenu.length) {
      return (
        <>
          <HeaderMenu>
            <MoreButton buttonType="icon" onClick={onToggleMenu}>
              <MoreVertIcon />
            </MoreButton>
            <MenuTitle>Menu</MenuTitle>
          </HeaderMenu>

          <List css={showMobileMenu ? null : hide}>
            {submenu.map(renderMenuItem)}
          </List>
        </>
      )
    }

    return (
      <>
        <HeaderMenu>
          <MenuTitle>Menu</MenuTitle>
        </HeaderMenu>

        { children }
      </>
    )
  }

  return (
    <Card>
      { renderContent() }
    </Card>
  )
}

SideMenu.propTypes = {
  submenu: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
}

SideMenu.defaultProps = {
  submenu: [],
  children: null,
}
